import { cn } from '../../utils/ui.util';
import { useTranslation } from '@rpi/i18n';
import * as React from 'react';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export enum InputType {
  TEXT = 'text',
  PASSWORD = 'password',
  EMAIL = 'email',
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false);
    const [currentType, setCurrentType] = React.useState(type);
    type TogglePasswordVisibilityEvent = React.MouseEvent<HTMLButtonElement>;

    const togglePasswordVisibility = (
      event: TogglePasswordVisibilityEvent,
    ): void => {
      event.preventDefault();
      if (currentType === InputType.PASSWORD) {
        setCurrentType(InputType.TEXT);
      } else {
        setCurrentType(InputType.PASSWORD);
      }
      setShowPassword(!showPassword);
    };
    const { t } = useTranslation(undefined, { keyPrefix: 'route.auth' });
    return (
      <div className="relative">
        <input
          type={currentType}
          className={cn(
            'flex h-10 w-full border border-blurb-gray-lightest  placeholder-shown:bg-[whitesmoke] px-3 py-2 ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:blurb-blue-light disabled:cursor-not-allowed disabled:opacity-50 rounded text-blurb-gray-darkest text-p3',
            className,
          )}
          ref={ref}
          {...props}
        />
        {type === InputType.PASSWORD && (
          <button
            type="button"
            className="absolute right-4 top-0 h-full text-p3 text-blurb-gray-dark"
            onClick={togglePasswordVisibility}
          >
            {showPassword ? t('hide') : t('show')}
          </button>
        )}
      </div>
    );
  },
);
Input.displayName = 'Input';

export { Input };
